import { render, staticRenderFns } from "./fButton.vue?vue&type=template&id=5713d093&"
import script from "./fButton.vue?vue&type=script&lang=js&"
export * from "./fButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports